module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "close_50x50.e0deb859.svg";